import { Outlet } from 'react-router-dom';
import { createContext, useContext, useState } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import { CommandPaletteProvider } from '@/components/CommandPalette';

interface LayoutContextType {
  sidebarOpen: boolean;
  setSidebarOpen: (open: boolean) => void;
}

const LayoutContext = createContext<LayoutContextType>({
  sidebarOpen: false,
  setSidebarOpen: () => {},
});

export const useLayout = () => useContext(LayoutContext);

export default function Layout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <LayoutContext.Provider value={{ sidebarOpen, setSidebarOpen }}>
      <CommandPaletteProvider>
        <div className="min-h-screen bg-gray-50">
          <Header />
          <Sidebar />
          <main className="lg:pl-56 pt-14">
            <div className="p-4 lg:p-6 max-w-[1600px] mx-auto">
              <Outlet />
            </div>
          </main>
          {sidebarOpen && (
            <div className="fixed inset-0 bg-black/30 backdrop-blur-sm z-30 lg:hidden" onClick={() => setSidebarOpen(false)} />
          )}
        </div>
      </CommandPaletteProvider>
    </LayoutContext.Provider>
  );
}
